module.exports = __webpack_public_path__ + "img/link-icon-flowers.f3c18dcd.svg";